import {Component, Input, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CampaignDTO, CommercialDTO, RequirementDTO} from "../../services/api/api";

@Component({
  selector: 'sb-time-status',
  templateUrl: './sb-time-status.component.html',
  styleUrls: ['./sb-time-status.component.scss'],
  standalone: false,
})
export class SbTimeStatusComponent implements OnInit {
  constructor(public translate: TranslateService) {}

  @Input() booking: CampaignDTO | CommercialDTO;
  @Input() type: string;

  ngOnInit(): void {}
}
